import { useState, useEffect } from 'react'
import Topbar from '../layouts/Topbar'
import PageHeader from '../components/PageHeader'
import SubHeader from '../components/SubHeader'
import CommonTable from '../components/Common_table'
import { useGlobalContext } from '../../context/Context'
import Adddesign from '../components/Add_design';
import Viewdesign from '../components/View_design'
import instance from '../../Utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Designstatus from '../components/Design_status'

const Design = () => {

  const title = { name: "Design", subheading: "Add to the design and view products", search: "Search Name", button: "Add Design" }
  const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Name', value: 'name' },
    { label: 'Created Date', value: 'createdAt' },
  ];
  const popupTitle = { title: 'subsubcategory', heading: 'Add Sub-Sub Category', subheading: 'Add your sub-sub-category to the list', editheading: 'Update Sub-Sub-Category', editsubheading: 'Update your sub-sub-category' }
  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Name", field: "name", },
    { label: "Design Image", field: "Bannerimage", },
    { label: "Status", field: "status", },
    { label: "price", field: "price", },
    { label: "Description", field: "description", },
    { label: "Created Date", field: "createddDate", },
    // { label: "Updated Date", field: "UpdatedDate",  },
    { label: "Actions", field: "action", }
  ];

  //usestate define
  const { loading, setLoading } = useGlobalContext();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [designsub, setDesignSub] = useState([]);
  const [getdesignsub, setgetdesignsub] = useState(false);
  const [selectedSubDesign, setselectedSubDesign] = useState(null);
  const { statusDialog, setstatusDialog } = useGlobalContext();
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [search, setSearch] = useState();
  // const [tabSearch, setTabSearch] = useState();
  const [filterdesigns, setFilterDesigns] = useState();
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  //fetch designs
  const fetchDesign = async (search, currentPage, rowsperpage) => {
    const params = {
      search,
      page: currentPage,
      limit: rowsperpage,
      // ...(tabSearch ? { consultation_type: tabSearch } : {}),
      ...(filterdesigns && filterdesigns !== '' && { sortBy: filterdesigns }),
    }
    try {
      const response = await instance.get('/Catalogue/getDesign', { params });
      const formatteddata = response?.data?.data?.map((designsub, index) => ({
        sno: index + 1,
        category: designsub?.category,
        subCategory: designsub?.subCategory,
        designtype: designsub?.design_type,
        Bannerimage: designsub?.picture,
        status: designsub?.status,
        name: designsub?.name,
        description: designsub?.description ? `${designsub?.description.substring(0, 100)}...` : '',
        price: designsub?.price,
        createddDate: new Date(designsub?.createdAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        UpdatedDate: new Date(designsub?.updatedAt).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
        }),
        designsubId: designsub?._id,
      }))

      setDesignSub(formatteddata);
      setTotalPages(response?.data?.totalPages);
      setCurrentPages(response?.data?.currentPage);
      setTotalcount(response?.data?.total);
    }
    catch (error) {
      console.log("error to fetch admins:", error.message)
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchDesign(search, currentPage, rowsperpage);
    setgetdesignsub(false)
    setLoading(true);
  }, [search, currentPage, rowsperpage, getdesignsub])

  // Handle Row Click for Edit
  const handleEditClick = (designsub) => {
    setselectedSubDesign(designsub);
    setEdit(true);
    setOpenDialog(true);
  };

  // Handle Row Click for view
  const handleViewClick = (designsub) => {
    setselectedSubDesign(designsub);
    setopenviewDialog(true)
  }

  // Handle Row Click for status change
  const handleStatusClick = (designsub) => {
    setselectedSubDesign(designsub);
    setstatusDialog(true); // Show the status popup
  };


  //filter function open menu
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseFilter = () => setAnchorEl(null);

  // Apply Filter Handler
  const handleDesignApplyFilter = () => {
    fetchDesign(search, currentPage, rowsperpage);
    setAnchorEl(null);
  };


  // Menu close handler
  const handleClearFilter = () => {
    setSearch('');
    setFilterDesigns('');
    setCurrentPages(1);
    setgetdesignsub(true)
    handleCloseFilter()
  };


  return (
    <>
      <Topbar />
      <section className='admin-catalogue'>
        <PageHeader
          title={title}
          files={false}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setSearch={setSearch}
        />
        <SubHeader
          menu={false}
          filter={false}
          isVisible={true}
          fetchfilterdesigns={filterOptions}
          filterdesigns={filterdesigns}
          setFilterDesigns={setFilterDesigns}
          setAnchorEl={setAnchorEl}
          anchorEl={anchorEl}
          open={open}
          handleClick={handleClick}
          handleCloseFilter={handleClearFilter}
          handleDesignApplyFilter={handleDesignApplyFilter}
          isDesignpage={true}
        />
        {loading ?
          <div className='loader-section'>
            <CircularProgress />
          </div>
          :
          <CommonTable
            columns={columns}
            rows={designsub}
            edit={edit}
            setEdit={setEdit}
            setopenviewDialog={setopenviewDialog}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            handleEditClick={handleEditClick}
            handleViewClick={handleViewClick}
            handleStatusClick={handleStatusClick}
            banner={true}
            menu={true}
            totalpages={totalpages}
            rowsperpage={rowsperpage}
            totalCount={totalCount}
            currentPage={currentPage}
            setCurrentPages={setCurrentPages}
          />
        }
        <Viewdesign
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          selectedSubDesign={selectedSubDesign}
          mode="Design"

        />
        <Adddesign
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          popupTitle={popupTitle}
          selectedSubDesign={selectedSubDesign}
          setgetdesignsub={setgetdesignsub}
          mode="Design"
        />
        <Designstatus
          statusDialog={statusDialog}
          setstatusDialog={setstatusDialog}
          selectedSubDesign={selectedSubDesign}
          setgetdesignsub={setgetdesignsub}
          mode="Design" // To differentiate the mode
        />
      </section>
    </>
  )
}

export default Design;
